const headStyles = () => [...document.querySelectorAll('link[rel="stylesheet"], style')].map((n) => n.outerHTML).join("\n");

let brandInfo = null;
export const setPrintBrand = (b) => { brandInfo = b; };
export const getPrintBrand = () => brandInfo;

const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const brandHtml = (receipt, title) => {
  if (!brandInfo?.name) return "";
  const meta = [brandInfo.address, brandInfo.phone].filter(Boolean).join(" · ");
  const date = new Date().toLocaleString(document.documentElement.lang === "ar" ? "ar-DZ-u-nu-latn" : document.documentElement.lang || "es");
  const logo = brandInfo.logoUrl ? `<img src="${brandInfo.logoUrl}" alt="" style="${receipt ? "width:56px;height:56px;margin:0 auto 4px;display:block" : "width:52px;height:52px"};object-fit:contain">` : "";
  if (receipt) return `<div data-brand style="text-align:center;border-bottom:1px dashed #777;padding-bottom:6px;margin-bottom:6px">${logo}<div style="font-weight:800">${esc(brandInfo.name)}</div>${meta ? `<div style="font-size:11px;color:#555">${esc(meta)}</div>` : ""}</div>`;
  return `<div data-brand style="display:flex;align-items:center;justify-content:space-between;gap:12px;border-bottom:2px solid #1F4E8C;padding-bottom:8px;margin-bottom:12px"><div style="display:flex;align-items:center;gap:12px">${logo}<div><div style="font-size:18px;font-weight:800;color:#1F4E8C">${esc(brandInfo.name)}</div>${meta ? `<div style="font-size:11px;color:#555">${esc(meta)}</div>` : ""}</div></div><div style="text-align:end"><div style="font-weight:700">${esc(title || "")}</div><div style="font-size:11px;color:#555" dir="ltr">${esc(date)}</div></div></div>`;
};

export const safeFileName = (s) => {
  const base = String(s || "orbit").normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^A-Za-z0-9._-]+/g, "-").replace(/^-+|-+$/g, "");
  return base || `orbit-${new Date().toISOString().slice(0, 10)}`;
};

export const brandHeaderHtml = (receipt, title) => brandHtml(receipt, title);
export const hasOwnLogo = (el) => !!el.querySelector('[data-testid="doc-header"], [data-testid="file-image"], [data-testid="invoice-logo"], [data-testid="pdf-report-logo"], [data-brand], img[alt][src*="/files/"], img[src*="/logo"], img[src^="blob:"], img[src^="data:"]');

export function printElement(el, { receipt = false, landscape = false, title, brand = true, heading } = {}) {
  const docTitle = safeFileName(title || `orbit-${new Date().toISOString().slice(0, 10)}`);
  if (!el) {
    const old = document.title;
    document.title = docTitle;
    window.print();
    setTimeout(() => { document.title = old; }, 1000);
    return undefined;
  }
  const page = receipt ? "@page { size: 80mm auto; margin: 3mm; }" : `@page { size: A4 ${landscape ? "landscape" : "portrait"}; margin: 10mm; }`;
  const width = receipt ? "74mm" : "auto";
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0;pointer-events:none";
  document.body.appendChild(frame);
  const doc = frame.contentDocument;
  const hasLogo = !brand || hasOwnLogo(el);
  const header = hasLogo ? "" : brandHtml(receipt, heading || "");
  doc.open();
  doc.write(`<!doctype html><html lang="${document.documentElement.lang || "es"}" dir="${document.documentElement.dir || "ltr"}"><head><meta charset="utf-8"><title>${docTitle}</title>${headStyles()}
<style>${page} html,body{background:#fff;margin:0;padding:0;color:#111} body{width:${width}} .print-root{visibility:visible!important;position:static!important;width:${width}!important;max-width:none!important;box-shadow:none!important;border:0!important;border-radius:0!important;overflow:visible!important;max-height:none!important;height:auto!important}
.print-root *{visibility:visible!important;overflow:visible!important;max-height:none!important} .no-print{display:none!important} tr{break-inside:avoid} img,svg{max-width:100%}</style></head>
<body class="${document.body.className.replace(/printing-\w+/g, "")}">${header}<div class="print-root">${el.outerHTML.replace(/\sclass="([^"]*)"/, ' class="$1 print-root-el"')}</div></body></html>`);
  doc.close();
  const win = frame.contentWindow;
  const go = () => {
    const imgs = [...doc.images].filter((i) => !i.complete).map((i) => new Promise((r) => { i.onload = i.onerror = r; }));
    const fonts = doc.fonts?.ready || Promise.resolve();
    Promise.all([fonts, ...imgs, new Promise((r) => setTimeout(r, 150))]).then(() => {
      win.focus();
      win.print();
      setTimeout(() => frame.remove(), 60000);
    });
  };
  if (doc.readyState === "complete") go(); else frame.onload = go;
}
